import { ArrowRight } from '@/components/ui/icons'
import { isByokPlansEnabled } from '@/lib/byokPlansFlag'
import { cn } from '@/lib/utils'

/** fal setup on the Free plan; signed-out visitors get the signup modal over it. `via=bar` names the page for the events. */
export const BAR_START_PATH = '/welcome?intent=fal&plan=free&via=bar'

// The button's box (size, margin) without its fill, so the line sits where the button would.
const UNAVAILABLE = 'cursor-default bg-transparent px-0 font-normal text-white/55 hover:bg-transparent'

/**
 * The Bar's primary CTA: straight into fal setup. Picking a paid plan lives on the pricing page.
 * Until the fal-key plans are purchasable (NEXT_PUBLIC_BYOK_PLANS_ENABLED) it is a line, not a way in.
 */
export function BarAccessCta({ cta, className }: { cta: string; className: string }) {
  if (!isByokPlansEnabled()) return <span className={cn(className, UNAVAILABLE)}>Available soon</span>
  return (
    <a href={BAR_START_PATH} data-cta={cta} className={className}>
      Get started
      <ArrowRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" />
    </a>
  )
}
